<template>
    <v-row>
        <v-col
            cols="8"
            data-testid="standard-header-menu"
            class="d-flex"
            id="menubar">
            <logo-header />
            <div class="menu-header-wrapp">
                <div class="menu-header-tab d-flex justify-space-around" role="tablist">
                    <template v-for="menu in headerMenus">
                        <v-tab
                            active-class="active"
                            :to="menu.href"
                            :target="menu.target"
                            :key="menu.title"
                        >
                            <div>
                                <span class="align-self-center menu-title font-weight-bold" v-text="menu.title.toUpperCase()" />
                            </div>
                        </v-tab>
                    </template>
                </div>
            </div>
        </v-col>
        <v-col cols="4">
            <standard-login-button
                v-if="displayProfileFeatures"
                data-testid="standard-login-button"
            />
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import StandardLoginButton from '@/components/bars/profileButtons/profileButtons';
import LogoHeader from '@/components/bars/logoHeader/LogoHeader';

export default {
    name: 'standard-menu',
    components: {
        StandardLoginButton,
        LogoHeader,
    },
    computed: {
        ...mapGetters({
            getLogoUrl: 'getLogoUrl',
            getAccessToken: 'jwt/getAccessToken',
            isClicSante: 'isClicSante',
        }),
        headerMenus() {
            return [
                {
                    'title': this.$i18n.t('header.clicsante.menu.takeAppt'),
                    'icon': false,
                    'iconImg': 'fas fa-home',
                    'href': 'take-appt',
                    'target': '_self',
                },
                {
                    'title': this.$i18n.t('header.clicsante.menu.cancelAppt'),
                    'icon': false,
                    'iconImg': 'fas fa-calendar-minus',
                    'href': 'cancel-appt',
                    'target': '_self',
                },
            ];
        },
        displayProfileFeatures() {
            return this.isClicSante;
        },
    },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables';

.menu-header-wrapp {
    position: relative;
    min-width: 500px;
    width: 100%;
    margin-left: 20%;
    @media only screen and (max-width: 1350px) {
        width: 75%;
    }
    @media only screen and (max-width: 1246px) {
        margin-left: 15%;
        width: 80%;
    }
}

.menu-header-tab {
    background: white;
    padding: 1rem;
    border-radius: 50px;
    @media only screen and (max-width: 1386px) {
        position: relative;
    }
    a {
        text-decoration: none;
        font-size: 16px!important;
        padding: 0 0!important;
        border-bottom: 3px solid white;
        @media only screen and (max-width: 1465px) {
            ont-size: 15px!important;
        }
        @media only screen and (max-width: 1264px) {
            font-size: 0.825rem!important;
        }

    }
    a.active {
        border-bottom: 3px solid $cs-color-secondary !important;
    }
    a:hover {
        cursor: pointer !important;
    }
}

.v-tab:before {
    background-color: transparent !important;
    transition: none !important;
    opacity: unset !important;
}
</style>
